import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { catchError, take } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { NewReleaseDialogComponent } from '../components/new-release-dialog/new-release-dialog.component';
import { ReleaseNotesService } from './release-notes.service';

@Injectable({ providedIn: 'root' })
export class NewReleaseDialogService {
    private readonly notes = inject(ReleaseNotesService);
    private readonly dialog = inject(MatDialog);
    private readonly storageKey = 'release-notes.lastVisitTime';
    public checkForNewRelease(): void {
        const now = new Date().toISOString();
        const previous = this.lastVisitTime();
        this.notes
            .getRecent()
            .pipe(
                take(1),
                catchError(() => EMPTY)
            )
            .subscribe((note) => {
                if (note && (!previous || new Date(previous).getTime() < this.releaseDateTime(note.releaseDate)))
                    this.dialog.open(NewReleaseDialogComponent);
                this.persistLastVisitTime(now);
            });
    }
    private lastVisitTime(): string | null {
        try {
            return localStorage.getItem(this.storageKey);
        } catch {
            return null;
        }
    }
    private persistLastVisitTime(value: string): void {
        try {
            localStorage.setItem(this.storageKey, value);
        } catch {
            // Storage can be unavailable in restricted browser contexts.
        }
    }
    private releaseDateTime(value: string | null | undefined): number {
        if (!value) return 0;
        return new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00.000Z` : value).getTime();
    }
}
